import React from "react";
import { connect } from "react-redux";
import { getBrideGroomNameFromURL, getHashtag } from "../../utils/string";

const Hashtag = ({ hashtag }) => {
  const { brideName, groomName } = getBrideGroomNameFromURL();

  const hashtagText = hashtag
    ? hashtag.includes("#") ? hashtag : `#${hashtag}`
    : getHashtag(brideName, groomName);

  return (
    <div className="hashtagContainer">
      <span className="orangeText mBtm30">{hashtagText}</span>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    hashtag: state.inviteDetails.invite?.hashtag,
  };
};

export default connect(mapStateToProps)(Hashtag);
